/* pdp atc mobile */
$(window).scroll(function () {
  if ($(window).width() < 769) {
    var stickyAtcMobOffset = $("#atc-main-wrapper").offset().top;

    // After scrolling to the #sticky-atc-mob element...
    if ($(window).scrollTop() >= stickyAtcMobOffset) {
      $(".sticky-mob-atc").css("display", "block");
    } else {
      $(".sticky-mob-atc").css("display", "none"); // Hide the element
    }
  }
});


/* Video play button */
const video = document.getElementById("myVideo");
const circlePlayButton = document.getElementById("playPauseBtn");

function togglePlay() {
	if (video.paused || video.ended) {
		video.play();
		video.setAttribute("controls", ""); // Add controls attribute
	} else {
		video.pause();
		video.removeAttribute("controls"); // Remove controls attribute
	}
}

circlePlayButton.addEventListener("click", togglePlay);

video.addEventListener("playing", function () {
	circlePlayButton.style.opacity = 0;
});

video.addEventListener("pause", function () {
	circlePlayButton.style.opacity = 1;
});


/* Sliders Video play button */
document.addEventListener("DOMContentLoaded", function() {
    var playButtons = document.querySelectorAll(".play");
    var players = document.querySelectorAll(".player");

    playButtons.forEach(function(button, index) {
      button.addEventListener("click", function() {
        if (players[index].paused) {
          players[index].play();
          button.style.display = 'none'; // Hide the button when video is played
          players[index].setAttribute("controls", ""); // Add controls attribute
        } else {
          players[index].pause(); // Pause the video if already playing
          button.style.display = 'flex'; // Show the button
          players[index].removeAttribute("controls"); // Remove controls attribute
        }
      });

      players[index].addEventListener("pause", function() {
        playButtons[index].style.display = 'flex'; // Show the button when video is paused
      });

      players[index].addEventListener("click", function() {
        if (players[index].paused) {
          players[index].play();
          playButtons[index].style.display = 'none'; // Hide the button when video is played
          players[index].setAttribute("controls", ""); // Add controls attribute
        } else {
          players[index].pause(); // Pause the video if already playing
          playButtons[index].style.display = 'flex'; // Show the button
          players[index].removeAttribute("controls"); // Remove controls attribute
        }
      });
    });
  });

document.addEventListener('DOMContentLoaded', function() {

  const localeInput = document.querySelector('input[name="locale_code"]');
  const localeCode = localeInput ? localeInput.value : '';
  const isItalian = localeCode === 'it';

  let swiperOne, swiperTwo;

  // ===== DEFAULT (NON-ITALIAN) =====
  if (!isItalian) {

    const thumbsOne = new Swiper('#thumbs-one', {
      slidesPerView: 4,
      spaceBetween: 10,
      watchSlidesProgress: true,
      freeMode: true
    });

    swiperOne = new Swiper('#slider-one', {
      loop: true,
      loopedSlides: 6,
      navigation: {
        nextEl: '#nextButton',
        prevEl: '#prevButton',
      },
      thumbs: { swiper: thumbsOne },
      on: {
        slideChange: function () {
          adjustMainSwiperHeight(swiperOne);
        }
      }
    });

  }

  // ===== ITALIAN VERSION =====
  if (isItalian) {

    const thumbsTwo = new Swiper('#thumbs-two', {
      slidesPerView: 4,
      spaceBetween: 10,
      watchSlidesProgress: true,
      freeMode: true
    });

    swiperTwo = new Swiper('#slider-two', {
      loop: true,
      loopedSlides: 6,
      navigation: {
        nextEl: '#nextButton', // ⚠️ IMPORTANT FIX
        prevEl: '#prevButton',
      },
      thumbs: { swiper: thumbsTwo },
      on: {
        slideChange: function () {
          adjustMainSwiperHeight(swiperTwo);
        }
      }
    });

  }

  // HEIGHT FIX
  function adjustMainSwiperHeight(swiper) {
    if (!swiper) return;
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (activeSlide) {
      swiper.el.style.height = activeSlide.offsetHeight + 'px';
    }
  }

});



/* product variant progress bar */
document.addEventListener('DOMContentLoaded', function () {
  const progressBar = document.querySelector('.ProductForm__ProgressBar');
  const progressItems = document.querySelectorAll('.ProductForm__ProgressBarItem');
  const variantInputs = document.querySelectorAll('.variant-input');

  function updateProgress(selectedQuantity) {
    const total = progressItems.length;
    const filledPercentage = (selectedQuantity / total) * 100;

    progressItems.forEach((item, index) => {
      const isActive = index < selectedQuantity;

      item.setAttribute('aria-current', index === selectedQuantity - 1 ? 'true' : 'false');
      item.style.background = isActive ? '#4b8177' : '#e0e0e0';
    });

    if (progressBar) {
      progressBar.style.background =
        `linear-gradient(to right, #4b8177 ${filledPercentage}%, #e0e0e0 ${filledPercentage}%)`;
      progressBar.setAttribute('data-quantity', selectedQuantity);
    }
  }

  function handleVariantChange() {
    const quantity = parseInt(this.dataset.quantity);
    if (!quantity) return;
    updateProgress(quantity);
  }

  variantInputs.forEach(input => {
    input.addEventListener('change', handleVariantChange);

    if (input.checked) {
      handleVariantChange.call(input);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  const localeInput = document.querySelector('input[name="locale_code"]');
  const localeCode = localeInput ? localeInput.value : '';

  const isItalian = localeCode === 'it';
  const isGermen = localeCode === 'de';

  // ===== GALLERIES =====
  const galleryOne = document.getElementById('gallery-one'); // default
  const galleryTwo = document.getElementById('gallery-two'); // italian

  if (galleryOne) {
    galleryOne.style.display = isItalian ? 'none' : 'block';
  }

  if (galleryTwo) {
    galleryTwo.style.display = isItalian ? 'block' : 'none';
  }

  // ===== VIDEO SECTIONS =====
  const defaultVideo = document.getElementById('hidden-video-italalian'); // fix typo if needed
  const germenVideo = document.getElementById('hidden-video-ital');
  const italianImageText = document.getElementById('hidden-section-ital');

  if (defaultVideo) {
    defaultVideo.style.display = isItalian ? 'none' : 'block';
  }

  if (germenVideo) {
    germenVideo.style.display = isGermen ? 'block' : 'none';
  }

    if (italianImageText) {
    italianImageText.style.display = isItalian ? 'block' : 'none';
  }

  // ===== FOOTER =====
  const footerDefault = document.getElementById('footer-content');
  const footerItalian = document.getElementById('footer-content-ital');

  if (footerDefault) {
    footerDefault.style.display = isItalian ? 'none' : 'block';
  }

  if (footerItalian) {
    footerItalian.style.display = isItalian ? 'block' : 'none';
  }

});


//VARIANT CHANGE PDP
document.addEventListener("DOMContentLoaded", function () {

  const variantDataEl = document.getElementById("variant-data");
  if (!variantDataEl) return;

  const variantData = JSON.parse(variantDataEl.textContent);
  const wrapper = document.getElementById("short-desc-wrapper");

  // fallback product description
  const productDesc = wrapper ? wrapper.innerHTML : "";

  // ALL VARIANT INPUTS (radio buttons)
  const variantInputs = document.querySelectorAll(".variant-input");

  variantInputs.forEach(input => {
    input.addEventListener("change", function () {

      if (!this.checked) return;

      // find selected variant ID from JSON script
      const variantsJson = document.querySelector('variant-radios script[type="application/json"]');
      if (!variantsJson) return;

      const variants = JSON.parse(variantsJson.textContent);

      // match selected variant by option value
      const selectedVariant = variants.find(v => v.option1 === this.value);

      if (!selectedVariant) return;

      const variantId = selectedVariant.id;
      const variantDesc = variantData[variantId];

      if (variantDesc && variantDesc.length) {

  const listHTML = variantDesc.map(item => `<li>${item}</li>`).join('');

  wrapper.innerHTML = `<ul class="short-desc-outer-wrap">${listHTML}</ul>`;

} else {
  wrapper.innerHTML = productDesc;
}

    });
  });

});

//Images PDP
document.addEventListener("DOMContentLoaded", function () {

  const lightbox = document.getElementById("image-lightbox");
  const lightboxImg = document.querySelector(".lightbox-img");
  const closeBtn = document.querySelector(".lightbox-close");

  // 🔥 ONLY TARGET MAIN IMAGES (NOT THUMBS)
  const images = document.querySelectorAll(".gallery-slider .swiper-slide img");

  images.forEach(img => {
    img.style.cursor = "zoom-in";

    img.addEventListener("click", function () {
      lightbox.style.display = "flex";
      lightboxImg.src = this.src;

      // ✅ disable scroll
      document.body.classList.add("lightbox-open");
    });
  });

  // CLOSE BUTTON
  closeBtn.addEventListener("click", closeLightbox);

  // CLICK OUTSIDE
  lightbox.addEventListener("click", function (e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });

  function closeLightbox() {
    lightbox.style.display = "none";

    // ✅ enable scroll back
    document.body.classList.remove("lightbox-open");
  }

});